import styled from "styled-components";
import {Wrapper} from "../../pages/blog/sections/banner/banner.styles";
import {down, up} from "styled-breakpoints";
import organicMeadowImage from "../../assets/images/organic-meadow-blossoms-vibrant-summer-sunset.png"
import {Modal} from "reactstrap";

export const AuthLayoutStyle = styled(Wrapper)`
    ${up("md")} {
        background: #f7fcf9;
        padding-top: 70px;
    }

    padding-top: 70px;

    > .first_content {
        background-size: cover !important;
        background-position: center center !important;
        background-repeat: no-repeat;
        background: linear-gradient(
                180deg,
                rgba(115, 82, 34, 0.32) 58.5%,
                rgba(49, 172, 20, 0) 100%
        ),
        url(${organicMeadowImage});
    }

    ${down("md")} {

        > .first_content {
            display: none;
        }

        > button.support {
            right: 30px;
        }
    }
`
export const AuthCustomModal = styled(Modal)`
    max-width: 820px;
    --bs-modal-width: 800px;
    border-radius: 45px;

    hr {
        margin-top: .5rem;
        margin-bottom: 1rem;
        border-color: rgba(55, 65, 81, 0.5);
        background-color: rgba(55, 65, 81, 0.5);
    }

    .modal-content {
        padding: 20px;
        overflow: auto;

        ${up("md")} {
            padding: 2rem 8rem;
        }

        ${down("md")} {
            padding: 0;
            transform: none !important;

            .modal-header {
                padding: 16px 0px;
                margin: 0 16px 0;
                font-weight: 700;
                font-size: 18px;
                line-height: 100%;
                letter-spacing: 0px;
                border-bottom: 1px solid var(--color-border-light);

                .modal-title {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    width: 100%;
                    flex-wrap: wrap;
                    align-items: center;
                }

                h5 > span {
                    flex: 1;
                }

                h5, span {
                    font-weight: inherit;
                    font-size: inherit;
                    line-height: inherit;
                    letter-spacing: inherit;
                }

                .close-btn {
                    position: static;
                    margin: 0;
                    padding: 0;
                    top: 0;

                    span {
                        display: none;
                    }
                }
            }
        }


        border-radius: 22px;
        max-height: 90vh;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }

    .modal-content::-webkit-scrollbar {
        display: none;
    }

    .modal-header {
        padding-top: 40px;
        border-bottom: none !important;
        justify-content: center;
        margin-bottom: 0;

        h5 {
            color: #2B2B2B;
            font-weight: 500;
            font-size: 27.6284px;
            line-height: 112.4%;
            text-transform: capitalize;
            text-align: center;

            ${up("md")} {
                font-weight: 700;
                font-size: 24px;
                line-height: 100%;
            }

            span.green {
                color: rgba(11, 156, 7, 1);
            }
        }

        .btn-close {
            display: none;
        }

        .close-btn {
            position: absolute;
            top: 4px;
            --bs-btn-hover-bg: transparent;
            --bs-btn-hover-border-color: transparent;
            --bs-btn-bg: transparent;
            --bs-btn-color: #000000;
            --bs-btn-hover-color: #000000;

            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-weight: 400;
            border: none;

            &:focus-visible, &:focus-within, &:focus {
                background: rgba(0, 0, 0, 0.04);
                color: black;
            }

            svg {
                margin-inline-end: 4px;
            }

            ${up("md")} {
                top: 28px;
                left: 15px;
            }

            left: 4px;
            cursor: pointer;
        }
    }

    .modal-body {
        .form-label {
            font-weight: 500;
            font-size: 16px;
        }

        .mb-3 {
            margin-bottom: 1rem !important;
        }

        form, .form {
            .input-group {

                .input-group-icon {
                    position: absolute;
                    font-size: 14px;
                    transform: translate(0px, -50%);
                    right: 10px;
                    top: 50%;
                    z-index: 5;
                    user-select: none;
                }
            }

            .input-group.has-icon {
                .form-control {
                    padding-inline-end: 45px;
                }
            }

            .otp-input-number {
                appearance: textfield;
            }

            .form-control, .form-select, .otp-input-number {
                border: 1px solid #CCCCCC;
                border-radius: 4px 4px 4px 4px !important;
                padding: 12px;
                background: #F9F9F9;

                font-weight: 400;
                font-size: 14px;
                line-height: 100%;

                &::placeholder {
                    color: #CCCCCC;
                }
            }

            .form-control:focus, .form-select:focus {
                box-shadow: none;
            }
        }

        > p {

        }

        > p {
            font-weight: 400;
            font-size: 13px;
            line-height: 100%;
            vertical-align: middle;

            a {
                font-weight: 600;
                color: var(--color-primary);
            }
        }
    }

    textarea.form-control {
        border-radius: 25px;
        padding: 20px;
        border: 1px solid #262626;
    }

    textarea.form-control:focus {
        box-shadow: none;
        border-color: unset;
    }

    .modal-footer {
        border-top: none !important;
        justify-content: center;
        margin-top: 1rem;

        button:not(.btn-outline-secondary) {
            background: #0b9c07;
        }

        button {
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 36px;
            padding: 8.5px;
            font-weight: 600;
            font-size: 20px;
            width: 100%;

            svg {
                margin-left: 4px;
            }
        }
    }

    ${down("md")} {
        min-width: 100% !important;
    }
`;
export const AuthCustomModalDescriptionStyle = styled.p`
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    vertical-align: middle;
    color: var(--color-text-slight-dark);

    ${down("md")} {
        font-size: 12px;
    }

    ${down("sm")} {
        font-size: 10px;
    }

    > a {
        font-weight: 600;
        --color-primary: var(--color-secondary);
        color: var(--color-secondary);
    }
`
export const AuthCustomModalDescriptionStyleB = styled.p.attrs({className: "modal-desc"})`
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    vertical-align: middle;
    color: var(--color-text-slight-dark);

    ${down("md")} {
        font-size: 12px;
    }

    ${down("sm")} {
        font-size: 10px;
    }

    > a, > .link {
        font-weight: 600;
        --color-primary: var(--color-primary);
        color: var(--color-primary, #0B9C07);
    }
`